import { Concept, ConceptValues } from '../../../../../../../types/Survey/Analysis/Concept'
import Copy from './Copy/Copy'
import Remove from './Remove/Remove'
import { useSelector } from 'react-redux'
import props from '../../../../../../../redux/props'

type Props = {
  values: ConceptValues
  concept: Concept
}

const Splitting: React.FC<Props> = ({ values, concept }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  return (
    <div className={`flex gap-5 items-center justify-between w-full`}>
      <div className="font-light text-md text-nowrap">{t.survey.analysis.calculation.values.splitting.headline}</div>
      <div className="w-1/2">
        <div className="flex gap-3 items-center justify-end">
          <Copy values={values} />
          <Remove values={values} concept={concept} />
        </div>
      </div>
    </div>
  )
}

export default Splitting
